const DEPRECATED_KINDS = {
  /**
   * @deprecated To be removed in favour of Flat
   */
  WHITE: 'White',
  /**
   * @deprecated To be removed in favour of Inverse
   */
  BLACK: 'Black',
  /**
   * @deprecated To be removed in favour of Subtle
   */
  GRAY: 'Gray',
  /**
   * @deprecated To be removed in favour of Primary
   */
  MINT: 'Mint',
} as const

const SEMANTIC_KINDS = {
  FLAT: 'Flat',
  INVERSE: 'Inverse',
  SUBTLE: 'Subtle',
  PRIMARY: 'Primary',
} as const

export const KINDS = {
  ...DEPRECATED_KINDS,
  ...SEMANTIC_KINDS,
} as const

type DeprecatedTagKind = (typeof DEPRECATED_KINDS)[keyof typeof DEPRECATED_KINDS]
type SemanticTagKind = (typeof SEMANTIC_KINDS)[keyof typeof SEMANTIC_KINDS]
type TagKind = DeprecatedTagKind | SemanticTagKind

const mapDeprecatedToSemanticKind: Record<DeprecatedTagKind, SemanticTagKind> = {
  White: SEMANTIC_KINDS.FLAT,
  Black: SEMANTIC_KINDS.INVERSE,
  Gray: SEMANTIC_KINDS.SUBTLE,
  Mint: SEMANTIC_KINDS.PRIMARY,
}

const isDeprecatedKind = (kind: TagKind): kind is DeprecatedTagKind => {
  return Object.values(DEPRECATED_KINDS).includes(kind as DeprecatedTagKind)
}

export const getSemanticKind = (kind: TagKind): SemanticTagKind => {
  return isDeprecatedKind(kind) ? mapDeprecatedToSemanticKind[kind] : kind
}
